import store from '@/store'

class JwtRefreshManager {
    constructor() {
        this.refreshTimer = null
        this.refreshMarginSeconds = 300 // 5 minuti prima della scadenza
    }

    parseJwtExpiration(jwt) {
        if (!jwt) return null
        try {
            const payload = JSON.parse(Buffer.from(jwt.split('.')[1], 'base64').toString())
            return payload.exp ? payload.exp * 1000 : null
        } catch (e) {
            return null
        }
    }

    start() {
        this.stop()

        const jwt = store.state.login.jwt
        if (!jwt) return

        const expiration = this.parseJwtExpiration(jwt)
        if (!expiration) return

        const delay = Math.max(0, expiration - Date.now() - this.refreshMarginSeconds * 1000)

        this.refreshTimer = setTimeout(() => this.refresh(), delay)
    }

    stop() {
        if (this.refreshTimer) {
            clearTimeout(this.refreshTimer)
            this.refreshTimer = null
        }
    }

    async refresh() {
        try {
            await store.dispatch('login/refreshJwt', { force: true })
            this.start() // Ri-schedula per il prossimo refresh
        } catch (e) {
            // Se il refresh fallisce, riprova tra 1 minuto
            this.refreshTimer = setTimeout(() => this.refresh(), 60000)
        }
    }
}

export default new JwtRefreshManager()
